import PropTypes from "prop-types";
import React from "react";

import DeleteDestinationForm from "v2/components/responsive/DeleteDestinationForm";
import ModalLink from "v2/components/responsive/ModalLink";

const DeleteDestinationLink = (props, context) => {
  const {params: {date, id, routeId}} = context;
  return (
    <ModalLink
      form={DeleteDestinationForm}
      label="Delete"
      url={`/${date}/${routeId}/${id}/delete`}
      {...props} />
  );
};

DeleteDestinationLink.contextTypes = {
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
};

export default DeleteDestinationLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/DeleteDestinationLink.js
 **/